"use client";

import { useQuery } from "@tanstack/react-query";
import { fetchCheckInRate } from "../services/insights-service";

const isValidDateLike = (v: string | Date | undefined | null) => {
  if (!v) return false;
  if (typeof v === "string") return /^\d{4}-\d{2}-\d{2}$/.test(v);
  return Number.isFinite(new Date(v).getTime());
};

type UseCheckInRateProps = {
  startDate: string;
  endDate: string;
  companyId: number;
  cities?: string[] | null;
  spaces?: number[] | null;
  users?: number[] | null;
  status?: number[] | null;
  types?: string[] | null;
  group_id?: number | null;
};

export function useCheckInRate({
  startDate,
  endDate,
  companyId,
  cities,
  spaces,
  users,
  status,
  types,
  group_id,
}: UseCheckInRateProps) {
  const enabled =
    isValidDateLike(startDate) && isValidDateLike(endDate) && !!companyId;

  const { data, isLoading } = useQuery({
    queryKey: [
      "check-in-rate",
      startDate,
      endDate,
      companyId,
      cities,
      spaces,
      users,
      status,
      types,
      group_id,
    ],
    queryFn: () =>
      fetchCheckInRate({
        startDate,
        endDate,
        companyId,
        cities,
        spaces,
        users,
        status,
        types,
        group_id,
      }),
    enabled,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading };
}
